module.exports = __webpack_public_path__ + "static/img/21.d6e29970.jpeg";